import { FuzzyMap } from 'utils/fuzzy';

export const getAgendaContactAttendeesFieldSchema = ({
    getChipProps,
    getLiteral,
    shouldRenderField,
}) => ({
    id: 'contact',
    serverId: 'idContacto',
    fieldConfiguration: 'idcontacto',
    type: 'fuzzySearchMultiple',
    clearValueWhenEmpty: true,
    mandatory: false,
    label: getLiteral('label_contact'),
    inputAttrs: {
        ...FuzzyMap.contactos,
        parentField: 'idempresa',
        parentFieldForBackend: 'idempresa',
        parentFieldForContext: 'account',
        shouldRenderField,
        chipWithLabel: true,
        getChipProps,
    },
    spaced: true,
});
